<template>
  <BaseTitle :schedule="schedule" :metadata-items="metadataList">
    <template #infoIcon="{ metadata }">
      <more-info
        :show-info-icons="metadata.showInfoIcons"
        :show-learn-more="false"
        :labels="moreInfoModalLabels"
        :abbr-content="feeScheduleTooltipContent"
        :detailed-content="feeScheduleTooltipContent"
      ></more-info>
    </template>
  </BaseTitle>
</template>

<script>
import MoreInfo from 'hypo-shared-utils/src/components/MoreInfo';
import BaseTitle from './BaseTitle';
import { FEE_SCHEDULE_TYPES } from '../../_config/constants';
import AssetBasedFeeScheduleMetadataMixin from '../../mixins/metadata/asset-based-fee-schedule-mixin';

const { TOTAL_FEE } = FEE_SCHEDULE_TYPES;

export default {
  name: 'asset-based-fee-schedule-title',
  components: {
    BaseTitle,
    MoreInfo,
  },
  mixins: [AssetBasedFeeScheduleMetadataMixin],
  props: {
    schedule: Object,
    showInfoIcons: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['translate', 'formatNumber'],
  computed: {
    metadataList() {
      const metadataList = [];
      if (this.feeScheduleDescription !== null) {
        metadataList.push({
          label: this.feeScheduleDescription,
          showInfoIcons: this.showInfoIcons,
        });
      }
      metadataList.push({
        label: this.maxDiscountDescription,
      });
      return metadataList;
    },
    feeScheduleDescription() {
      const labelKeyMap = {
        0: 'tieredFee',
        1: 'tieredFee',
        2: 'totalFee',
      };
      const labelKey = labelKeyMap[this.schedule.feeScheduleType];
      if (!labelKey) {
        return null;
      }
      return this.translate(labelKey);
    },
    feeScheduleTooltipContent() {
      let feeScheduleTooltipLabelKey = 'tieredFeeMsg';
      if (this.schedule.feeScheduleType === TOTAL_FEE) {
        feeScheduleTooltipLabelKey = 'totalFeeMsg';
      }
      return this.translate(feeScheduleTooltipLabelKey);
    },
    moreInfoModalLabels() {
      return {
        modalTitle: this.translate('infoModalTitle'),
        learnMore: this.translate('learnMore'),
        close: this.translate('close'),
      };
    },
  },
};
</script>
